/*=========================================================================================
  File Name: oneSignalConfig.js
  Description: OneSignal configuration. OneSignal is used for pushnotifications
==========================================================================================*/

import OneSignalVue from "onesignal-vue";

export default function configureOneSignal(Vue) {
  Vue.use(OneSignalVue);
  Vue.prototype.$OneSignal.init({
    appId: "6fb5bfbf-3262-4055-9b22-7460a818ed69",
    allowLocalhostAsSecureOrigin: true,
  });
}

export function oneSignalCordovaInit() {
  window.plugins.OneSignal.setAppId("6fb5bfbf-3262-4055-9b22-7460a818ed69");
  window.plugins.OneSignal.setNotificationOpenedHandler((jsonData) => {
    console.log("Notification opened:", JSON.stringify(jsonData));
  });
  window.plugins.OneSignal.promptForPushNotificationsWithUserResponse(
    (accepted) => {
      console.log("User accepted notifications:", accepted);
    }
  );
}
